import { Badge, Group } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { getMspCategoryLabel } from "../../../utils/getMspCategoryLabel";
import type { FlatLocationOverviewData } from "../../LocationOverview.types";

function getMsbColumn(): MRT_ColumnDef<FlatLocationOverviewData> {
  return {
    accessorKey: "msb",
    header: "MSB",
    minSize: 350,
    enableGrouping: false,
    Cell: ({ row }) => {
      const { location } = row.original;
      return (
        <Group gap="sm" wrap="nowrap">
          {location.meteringServiceProviderName}
          <Badge color="neutral" size="sm">
            {getMspCategoryLabel(location.meteringServiceProviderCategory)}
          </Badge>
        </Group>
      );
    }
  };
}

export { getMsbColumn };
